import { render, staticRenderFns } from "./small.vue?vue&type=template&id=2ba604d7&scoped=true&"
import script from "./small.vue?vue&type=script&lang=js&"
export * from "./small.vue?vue&type=script&lang=js&"
import style0 from "./small.vue?vue&type=style&index=0&id=2ba604d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba604d7",
  null
  
)

export default component.exports